import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export interface BillingMilestone {
  id: number;
  workId: number;
  workName: string;
  description: string;
  percentage?: number | null;
  value?: number | null;
  expectedDate?: string | null;
  // [3.7.1] Computed in GetBillingMilestones: is there a non-anulada ClientInvoice for this marco?
  isBilled?: boolean;
  invoiceId?: number | null;
  invoiceNumber?: string | null;
  created: string;
  lastModified: string;
}

export interface BillingMilestonePayload {
  workId: number;
  description: string;
  percentage?: number | null;
  value?: number | null;
  expectedDate?: string | null;
}

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(
      response.status,
      text || response.statusText,
    );
  }

  return (await response.json()) as T;
}

export function getBillingMilestones(
  workId?: number,
): Promise<BillingMilestone[]> {
  const query =
    workId !== undefined && workId !== null && Number.isFinite(workId)
      ? `?workId=${workId}`
      : "";
  return request<BillingMilestone[]>(`/api/billingmilestones${query}`);
}

export function getBillingMilestoneById(
  milestoneId: number,
): Promise<BillingMilestone> {
  return request<BillingMilestone>(`/api/billingmilestones/${milestoneId}`);
}

export function createBillingMilestone(
  payload: BillingMilestonePayload,
): Promise<BillingMilestone> {
  return request<BillingMilestone>("/api/billingmilestones", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function updateBillingMilestone(
  milestoneId: number,
  payload: BillingMilestonePayload,
): Promise<BillingMilestone> {
  return request<BillingMilestone>(`/api/billingmilestones/${milestoneId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export async function deleteBillingMilestone(
  milestoneId: number,
): Promise<void> {
  const response = await fetch(
    `${apiBaseUrl}/api/billingmilestones/${milestoneId}`,
    {
      method: "DELETE",
      credentials: "include",
    },
  );

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }
}
